export const isCI = (): boolean => {
	return import.meta.env.VITE_RUN_ENV === 'ci';
};

export const isProduction = (): boolean => {
	return import.meta.env.VITE_RUN_ENV === 'production';
};
